import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, borderRadius, spacing, mediaQueries } =
    useTheme();

  return {
    confirmation: css`
      display: grid;
      align-items: baseline;
      grid-gap: ${spacing.s};

      ${breakpoints.l} {
        grid-template-columns: 1fr 1fr;
        grid-gap: ${spacing.m};
        padding: ${spacing.xxl};

        button {
          &:focus:not(:hover) {
            text-decoration: underline;
          }
        }
      }

      ${mediaQueries.zoomedIn} {
        overflow: auto;
        height: 100%;
      }
    `,
    answer: css`
      padding-bottom: ${spacing.s};
      ${breakpoints.l} {
        padding-bottom: 1.5rem;
      }
      &:last-child {
        padding-bottom: 0;
        button {
          margin: auto;
        }
      }
    `,
    title: css`
      color: ${colors.white};
      font-size: ${spacing.m};
      font-style: unset;
      line-height: 2.25rem;
      text-align: center;
      font-family: 'FS Dillon';
      font-size: 25.92px;

      ${breakpoints.l} {
        text-align: left;
        font-size: 35.54px;
        line-height: 3.125rem;
        outline: 0;
        font-family: 'FS Dillon';
        font-style: unset;
      }
    `,
    helpText: css`
      color: ${colors.lightBlue};
      text-align: center;
      font-size: 18px;

      ${breakpoints.l} {
        text-align: left;
        font-size: 20px;
      }
    `,
    options: css`
      li {
        padding-bottom: ${spacing.xs};
      }
      button {
        width: 100%;
        font-size: 1.125rem;
        font-weight: 700;
        padding: 1.1rem ${spacing.s};
        border:  solid transparent;

        &:focus:not(:hover) {
          border: 3px solid ${colors.navy};
          border-radius: ${borderRadius.s};
          background-color: ${colors.white};
          outline: 0;
        }
      }

      ${mediaQueries.zoomedIn} {
        padding-left: 5px;
        padding-right: 5px;
      }
    `,
  };
};
